export default __webpack_public_path__ + "static/media/crew-09.74e603a8.svg";